/**
 *
 * EventRedirect
 *
 */

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import QRCode from 'qrcode';
import Swal from 'sweetalert2';

import Spinner from '@/components/Spinner.vue';

import { getWechatUrlMp } from '@/utils/wechat';
import { LoginMixin } from '@/scripts/Login/Login.mixin';

import { LOADING_MESSAGE } from './PlvLiveLogin.constants';

export default {
  name: 'PlvLiveLogin',

  components: {
    Spinner,
  },

  mixins: [LoginMixin],

  data() {
    return {
      loadingMessage: LOADING_MESSAGE,

      isShowMobilePopup: false,
      urlPopupIframe: '',

      isShowMessageBox: false,

      qrCode: '',
    };
  },

  computed: {
    ...mapState('PlvLiveLogin', {
      ms_plvWatchLink: 'plvWatchLink',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    c_isLogin() {
      return Boolean(this.mg_userInfo.studentId);
    },

    c_isLoading() {
      return this.c_isLogin || (this.$route.query.code && this.$route.query.state);
    },
  },

  methods: {
    ...mapMutations({
      mm_SET_IS_GET_ISLOGIN: 'SET_IS_GET_ISLOGIN',
    }),

    ...mapActions('PlvLiveLogin', {
      ma_getPlvWatchLink: 'getPlvWatchLink',
    }),

    toggleIsAgreed() {
      this.isAgreed = !this.isAgreed;
    },

    showLegalFile(urlPopupIframe) {
      if (this.ms_isMobile) {
        this.isShowMobilePopup = true;
        this.urlPopupIframe = urlPopupIframe;
      } else {
        window.open(urlPopupIframe, '_blank');
      }
    },

    hideLegalFile() {
      this.isShowMobilePopup = false;
      this.urlPopupIframe = '';
    },

    hideAgreementMessage() {
      this.isShowMessageBox = false;
    },

    agreeAndLogin() {
      this.toggleIsAgreed();
      this.hideAgreementMessage();
      this.doLogin();
    },

    ///
    doLogin() {
      this.isInvalid = false;
      if (!this.isAgreed) {
        this.isShowMessageBox = true;
      } else {
        window.location.href = getWechatUrlMp(this.$route.fullPath);
      }
    },

    async getPlvWatchLink() {
      await this.ma_getPlvWatchLink({
        channelId: this.$route.params.channelId,
        invitePosterId: this.$route.query.invitePosterId,
      });
      if (this.ms_plvWatchLink && this.ms_plvWatchLink.watchUrl) {
        window.location.href = this.ms_plvWatchLink.watchUrl;
      }
    },

    ///
    _afterLogin() {
      this.getPlvWatchLink();
    },

    async copyUrl() {
      await navigator.clipboard.writeText(this.$route.fullPath);
      Swal.fire({
        width: '400px',
        backdrop: false,
        icon: 'success',
        title: '复制成功',
        showConfirmButton: false,
        timer: 800,
      });
    },

    async PlvLiveLoginCreated() {
      if (this.c_isLogin) {
        this.mm_SET_IS_GET_ISLOGIN(true);
        this.getPlvWatchLink();
      } else if (this.$route.query.code && this.$route.query.state) {
        await this.wxLogin({
          code: this.$route.query.code,
          state: this.$route.query.state,
          type: 2,
          vendorId: this.vendorId,
        });
        if (this.loginStatus === 200) {
          if (this.wechatBinding) {
            await this.getUserInfo();
            this._afterLogin();
          } else {
            this.step = 'wechatBinding';
          }
        } else {
          this.isInvalid = true;
          this.afterWxLoginError();
        }
      } else if (!this.ms_isWechatBrowser) {
        this.qrCode = await QRCode.toDataURL(this.$route.fullPath, { errorCorrectionLevel: 'L' });
      }
    },
  },

  created() {
    this.PlvLiveLoginCreated();
  },
};
